export default {
  palettes: {
    en: 'Palettes',
  },
  all: {
    en: 'all',
  },

  eye: {
    en: 'Eye',
  },
  mascara: {
    en: 'Mascara',
  },
  eyebrow: {
    en: 'Eyebrow',
  },
  eyeTreatment: {
    en: 'Eye Treatment',
  },
  eyeLiner: {
    en: 'Eyeliner',
  },
  eyePencils: {
    en: 'Eye Pencils',
  },
  tattooLiner: {
    en: 'Tattoo Liner',
  },
  liquidLiner: {
    en: 'Liquid Liner',
  },
  eyePrimer: {
    en: 'Eye Primer',
  },
  eyeshadow: {
    en: 'Eyeshadow',
  },

  lip: {
    en: 'Lip',
  },
  lipColor: {
    en: 'Lip Color',
  },
  lipColorPencil: {
    en: 'Lip Color Pencil',
  },
  lipCrayons: {
    en: 'Lip Crayons',
  },
  lipLiners: {
    en: 'Lip Liner',
  },
  lipPaint: {
    en: 'Lip Paint',
  },
  lipstick: {
    en: 'Lipstick',
  },
  lipgloss: {
    en: 'Lip Gloss',
  },

  // face
  face: {
    en: 'Face',
  },
  facePrimer: {
    en: 'Face Primer',
  },
  concealer: {
    en: 'Concealer',
  },
  faceFoundation: {
    en: 'Foundation',
  },

  // cheek
  cheek: {
    en: 'Cheek',
  },
  cheekBlush: {
    en: 'Blush',
  },
  cheekHighlight: {
    en: 'Highlight',
  },

  // tools
  tools: {
    en: 'Tools',
  },
  brushes: {
    en: 'Brushes',
  },
}
